require('./bootstrap');

window.Vue = require('vue').default;

import Vuelidate from 'vuelidate';
Vue.use(Vuelidate);

require("bootstrap-datepicker");

$(document).on("ready", function() {
    $('input[type="file"]').on("change", function(e) {
        $("#file-chosen").text('Poza a fost încărcată cu succes!');

    });
});

Vue.component('legendar', require('./components/Legendar.vue').default);

const app = new Vue({
    el: '#app',
});